import { Injectable } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { TreeNodeDto } from '../models/tree-node-dto';
import { LanguageService } from './language.service';
import { Observable, Subscription } from 'rxjs';
import { CustomTreeNode } from '../models/custom-tree-node';

@Injectable({
  providedIn: 'root'
})
export class TreeService {


  constructor() {}

  public transformToTreeNode(serverTreeNode: TreeNodeDto): CustomTreeNode {
    const heb = serverTreeNode.treeNodeName?.hebrew || '';
    const eng = serverTreeNode.treeNodeName?.english || '';
    const treeNode: CustomTreeNode = {
      multiLangLabel: serverTreeNode.treeNodeName,
      data: serverTreeNode.mid,
      wid: serverTreeNode.wid,
      address: serverTreeNode.address,
      key: serverTreeNode.mid.toString(),
      equalWids: serverTreeNode.equalWids,
      unprefWids: serverTreeNode.unprefWids,
      searchableText: [heb, eng].filter(Boolean).join(' ')
    };
    if (serverTreeNode.children) {
      treeNode.children = serverTreeNode.children.map((child) =>
        this.transformToTreeNode(child)
      );
    }
    return treeNode;

  }


  public findNodeById(node: CustomTreeNode, id: string): CustomTreeNode | null {
    if (node.data.toString() === id) {
      return node;
    } else if (node.children) {
      let result = null;
      for (let i = 0; result == null && i < node.children.length; i++) {
        result = this.findNodeById(node.children[i], id);
      }
      return result;
    }
    return null;
  }

  // Find node by numeric ID, matching against the numeric part of composite IDs
  // e.g., searching for "1202" will match node with data "1202-מקוש-דלת-Door handle"
  public findNodeByNumericId(node: CustomTreeNode, numericId: string): CustomTreeNode | null {
    const nodeNumericId = node.data.toString().split('-')[0];
    if (nodeNumericId === numericId) {
      return node;
    } else if (node.children) {
      let result = null;
      for (let i = 0; result == null && i < node.children.length; i++) {
        result = this.findNodeByNumericId(node.children[i], numericId);
      }
      return result;
    }
    return null;
  }

  public findNodeByAddress(node: CustomTreeNode, address: string): CustomTreeNode | null {
    if (node.address === address) {
      return node;
    } else if (node.children) {
      let result = null;
      for (let i = 0; result == null && i < node.children.length; i++) {
        result = this.findNodeByAddress(node.children[i], address);
      }
      return result;
    }
    return null;
  }
}
